export const translations = {
    en: {
        welcomeMessage: "🎬 Welcome to Vision AI Stream, {username}!",
        tagline: "🚀 Cut, edit, merge, and make it shine – with VisionAI, you're in charge!",
        upgradePlan: "Upgrade Plan",
        uploadVideo: 'Upload Video',
        uploadSubtitle: 'Upload Subtitle',
        transcribe: 'Transcribe',
        embed: 'Embed',
        dubbing: 'Dubbing',
        join: 'Join',
        cut: 'Cut',
        voiceClone: 'Voice Clone',
        lipMovement: 'Lip Movement',
        lipEnhance: 'Lip Enhance',
        startTime: 'Start Time',
        endTime: 'End Time',
        inputLanguage: 'Input Language',
        outputLanguage: 'Output Language',
        page: "Page",
        transitionRatioLabel: "Transition Ratio",
        transitionRatioTooltip: "Sets how long each subtitle stays on screen. Higher = stays longer, Lower = switches faster.",
        transitionRatioImageTooltip: "The generated video duration will be approximately {seconds} seconds.",
        dialoguePlaceholder: "Enter only one keyword to cut the dialogue or topic",
        imagePromptPlaceholder: "Describe what should happen in this image",
        cutOriginalVideo: 'Cut Original Video',
        cutSuccess: 'Cut successfully completed!',
        downloadCutVideo: 'Download Cut Video',
        downloadCutSubtitle: 'Download Cut Subtitle',
        processVideo: 'Process Video',
        cutVideoByDialogue: 'Cut Video by Dialogue',
        cutVideoBySubtitle: 'Cut Video by Subtitle',
        uploadSuccess: 'Video processed successfully!',
        joinVideos: 'Join Videos',
        joinSuccess: 'Videos successfully joined!',
        joinError: 'You need at least two videos to join.',
        logout: 'Logoff',
        cleanupSuccess: 'Cleanup successfully performed.',
        cleanupError: 'Error while cleaning up.',
        logoutError: 'Error while logging out.',
        errorJoinVideos: 'Error while joining videos.',
        audioError: 'Failed to play audio.',
        audioUnsupported: 'Your browser does not support the audio element.',
        encodingNotSupported: 'Encoding not supported:',
        fallbackUtf8: 'using UTF-8 as fallback.',
        errorDetectSubtitleLanguage: 'Error detecting subtitle language.',
        uploadVideoError: 'Please upload the video before sending it.',
        uploadSubtitleError: 'Please upload the subtitle before sending it.',
        errorCorrectSubtitles: 'Error correcting subtitles.',
        errorCutSubtitle: 'Error decoding or cutting subtitle.',
        uploadError: 'Error uploading and cutting video.',
        uploadErrorStatus: 'The file size of {file.size} MB exceeds the upload limit. The server responded with status: {status}',
        uploadErrorConnection: 'Could not connect to the server. Please check your network and try again.',
        uploadErrorMessage: 'An unexpected error occurred: {message}',
        dailyLimitExceeded: 'Daily upload limit exceeded. Limit: {dailyLimit}',
        fileSizeExceeded: 'The file size of {fileSize} MB exceeds the maximum allowed size of {maxFileSize} MB.',
        insufficientStorage: 'Insufficient storage. Available: {availableStorage} GB.',
        unexpectedError: 'An unexpected error occurred: {message}',
        connectionError: 'Could not connect to the server. Please check your network.',
        feedbackTitle: "We value your feedback!",
        feedbackPlaceholder: "Write your feedback here...",
        feedbackSubmitted: "Feedback submitted!",
        feedbackSent: "Feedback sent!",
        sendFeedback: "Send Feedback"
    },
    pt: {
        welcomeMessage: "🎬 Bem-vindo ao Vision AI Stream, {username}!",
        tagline: "🚀 Corta, edita, junta e faz brilhar – no VisionAI, é só comandar!",
        upgradePlan: "Fazer Upgrade do Plano",
        uploadVideo: 'Enviar Vídeo',
        uploadSubtitle: 'Enviar Legenda',
        transcribe: 'Legendar',
        embed: 'Embutir',
        dubbing: 'Dublar',
        join: 'Juntar',
        cut: 'Cortar',
        voiceClone: 'Clonar Voz',
        lipMovement: 'Movimento Labial',
        lipEnhance: 'Realçar Lábios',
        startTime: 'Hora de início',
        endTime: 'Hora de término',
        inputLanguage: 'Idioma de Entrada',
        outputLanguage: 'Idioma de Saída',
        page: "Página",
        transitionRatioLabel: "Fator de Transição",
        transitionRatioTooltip: "Define quanto tempo cada legenda fica visível. Maior = fica mais tempo, Menor = troca mais rápido.",
        transitionRatioImageTooltip: "A duração do vídeo gerado será de aproximadamente {seconds} segundos.",
        dialoguePlaceholder: "Digite apenas uma palavra-chave para cortar o diálogo ou assunto",
        imagePromptPlaceholder: "Descreva o que deve acontecer nesta imagem",
        cutOriginalVideo: 'Cortar Vídeo Original',
        cutSuccess: 'Corte realizado com sucesso!',
        downloadCutVideo: 'Baixar Vídeo Cortado',
        downloadCutSubtitle: 'Baixar Legenda Cortada',
        processVideo: 'Processar Vídeo',
        cutVideoByDialogue: 'Cortar Vídeo por Diálogo',
        cutVideoBySubtitle: 'Cortar Vídeo por Legenda',
        uploadSuccess: 'Vídeo processado com sucesso!',
        joinVideos: 'Juntar Vídeos',
        joinSuccess: 'Vídeos juntados com sucesso!',
        joinError: 'Você precisa de pelo menos dois vídeos para juntar.',
        logout: 'Sair',
        cleanupSuccess: 'Limpeza realizada com sucesso.',
        cleanupError: 'Erro ao realizar a limpeza.',
        logoutError: 'Erro ao tentar fazer logoff.',
        errorJoinVideos: 'Erro ao juntar vídeos.',
        audioError: 'Falha ao tocar o áudio.',
        audioUnsupported: 'Seu navegador não suporta o elemento de áudio.',
        encodingNotSupported: 'Codificação não suportada:',
        fallbackUtf8: 'usando UTF-8 como fallback.',
        errorDetectSubtitleLanguage: 'Erro ao detectar o idioma da legenda.',
        uploadVideoError: 'Por favor, faça o upload do vídeo antes de enviá-lo.',
        uploadSubtitleError: 'Por favor, faça o upload da legenda antes de enviá-la.',
        errorCorrectSubtitles: 'Erro ao corrigir as legendas.',
        errorCutSubtitle: 'Erro ao decodificar ou cortar a legenda.',
        uploadError: 'Erro ao enviar e cortar o vídeo.',
        uploadErrorStatus: 'O tamanho do arquivo de {file.size} MB excede o limite de envio. O servidor respondeu com o status: {status}',
        uploadErrorConnection: 'Não foi possível conectar ao servidor. Verifique sua conexão de rede e tente novamente.',
        uploadErrorMessage: 'Ocorreu um erro inesperado: {message}',
        dailyLimitExceeded: 'Limite diário de uploads atingido. Limite: {dailyLimit}',
        fileSizeExceeded: 'O tamanho do arquivo de {fileSize} MB excede o tamanho máximo permitido de {maxFileSize} MB.',
        insufficientStorage: 'Armazenamento insuficiente. Disponível: {availableStorage} GB.',
        unexpectedError: 'Ocorreu um erro inesperado: {message}',
        connectionError: 'Não foi possível conectar ao servidor. Verifique sua rede.',
        feedbackTitle: "Nós valorizamos seu feedback!",
        feedbackPlaceholder: "Escreva seu feedback aqui...",
        feedbackSubmitted: "Feedback enviado!",
        feedbackSent: "Feedback enviado!",
        sendFeedback: "Enviar Feedback"
    },
    es: {
        welcomeMessage: "🎬 ¡Bienvenido a Vision AI Stream, {username}!",
        tagline: "🚀 Corta, edita, une y haz que brille – en VisionAI, tú mandas!",
        upgradePlan: "Actualizar Plan",
        uploadVideo: 'Subir Video',
        uploadSubtitle: 'Subir Subtítulo',
        transcribe: 'Transcribir',
        embed: 'Incorporar',
        dubbing: 'Doblaje',
        join: 'Unir',
        cut: 'Cortar',
        voiceClone: 'Clonar Voz',
        lipMovement: 'Movimiento Labial',
        lipEnhance: 'Realzar Labios',
        startTime: 'Hora de Inicio',
        endTime: 'Hora de Finalización',
        inputLanguage: 'Idioma de Entrada',
        outputLanguage: 'Idioma de Salida',
        page: "Página",
        transitionRatioLabel: "Factor de Transición",
        transitionRatioTooltip:"Establece cuánto tiempo permanece cada subtítulo en pantalla. Mayor = permanece más tiempo, Menor = cambia más rápido.",
        transitionRatioImageTooltip: "La duración del video generado será de aproximadamente {seconds} segundos.",
        dialoguePlaceholder: "Introduce solo una palabra clave para recortar el diálogo o tema",
        imagePromptPlaceholder: "Describe lo que debería suceder en esta imagen",
        cutOriginalVideo: 'Cortar Video Original',
        cutSuccess: '¡Corte realizado con éxito!',
        downloadCutVideo: 'Descargar Video Cortado',
        downloadCutSubtitle: 'Descargar Subtítulo Cortado',
        processVideo: 'Procesar Video',
        cutVideoByDialogue: 'Cortar Video por Diálogo',
        cutVideoBySubtitle: 'Cortar Video por Subtítulo',
        uploadSuccess: '¡Video procesado con éxito!',
        joinVideos: 'Unir Videos',
        joinSuccess: '¡Videos unidos con éxito!',
        joinError: 'Necesitas al menos dos videos para unir.',
        logout: 'Cerrar sesión',
        cleanupSuccess: 'Limpieza realizada con éxito.',
        cleanupError: 'Error al realizar la limpieza.',
        logoutError: 'Error al cerrar sesión.',
        errorJoinVideos: 'Error al unir videos.',
        audioError: 'Error al reproducir el audio.',
        audioUnsupported: 'Su navegador no admite el elemento de audio.',
        encodingNotSupported: 'Codificación no compatible:',
        fallbackUtf8: 'usando UTF-8 como respaldo.',
        errorDetectSubtitleLanguage: 'Error al detectar el idioma del subtítulo.',
        uploadVideoError: 'Por favor, suba el video antes de enviarlo.',
        uploadSubtitleError: 'Por favor, suba el subtítulo antes de enviarlo.',
        errorCorrectSubtitles: 'Error al corregir subtítulos.',
        errorCutSubtitle: 'Error al decodificar o cortar el subtítulo.',
        uploadError: 'Error al subir y cortar el video.',
        uploadErrorStatus: 'El tamaño del archivo de {file.size} MB excede el límite de carga. El servidor respondió con el estado: {status}',
        uploadErrorConnection: 'No se pudo conectar al servidor. Verifique su conexión de red e intente nuevamente.',
        uploadErrorMessage: 'Ocurrió un error inesperado: {message}',
        dailyLimitExceeded: 'Se alcanzó el límite diario de cargas. Límite: {dailyLimit}',
        fileSizeExceeded: 'El tamaño del archivo de {fileSize} MB excede el tamaño máximo permitido de {maxFileSize} MB.',
        insufficientStorage: 'Almacenamiento insuficiente. Disponible: {availableStorage} GB.',
        unexpectedError: 'Ocurrió un error inesperado: {message}',
        connectionError: 'No se pudo conectar al servidor. Por favor, verifique su red.',
        feedbackTitle: "¡Valoramos tus comentarios!",
        feedbackPlaceholder: "Escribe tu opinión aquí...",
        feedbackSubmitted: "¡Comentarios enviados!",
        feedbackSent: "Comentarios enviados!",
        sendFeedback: "Enviar Comentarios"
    },
    fr: {
        welcomeMessage: "🎬 Bienvenue sur Vision AI Stream, {username} !",
        tagline: "🚀 Coupez, éditez, fusionnez et faites briller – avec VisionAI, c'est vous qui commandez !",
        upgradePlan: "Mettre à niveau le plan",
        uploadVideo: 'Télécharger Vidéo',
        uploadSubtitle: 'Télécharger Sous-titre',
        transcribe: 'Transcrire',
        embed: 'Intégrer',
        dubbing: 'Doublage',
        join: 'Joindre',
        cut: 'Couper',
        voiceClone: 'Clonage de Voix',
        lipMovement: 'Mouvement Labial',
        lipEnhance: 'Améliorer les Lèvres',
        startTime: 'Heure de Début',
        endTime: 'Heure de Fin',
        inputLanguage: 'Langue d\'Entrée',
        outputLanguage: 'Langue de Sortie',
        page: "Page",
        transitionRatioLabel: "Facteur de Transition",
        transitionRatioTooltip: "Définit la durée d’affichage de chaque sous-titre. Plus élevé = sous-titre plus long, Plus bas = changement plus rapide.",
        transitionRatioImageTooltip: "La durée de la vidéo générée sera d’environ {seconds} secondes.",
        dialoguePlaceholder: "Saisissez un seul mot-clé pour couper le dialogue ou le sujet",
        imagePromptPlaceholder: "Décrivez ce qui devrait se passer dans cette image",
        cutOriginalVideo: 'Couper Vidéo Originale',
        cutSuccess: 'Coupe réussie !',
        downloadCutVideo: 'Télécharger Vidéo Coupée',
        downloadCutSubtitle: 'Télécharger Sous-titre Coupé',
        processVideo: 'Traiter la Vidéo',
        cutVideoByDialogue: 'Couper Vidéo par Dialogue',
        cutVideoBySubtitle: 'Couper Vidéo par Sous-titre',
        uploadSuccess: 'Vidéo traitée avec succès !',
        joinVideos: 'Joindre Vidéos',
        joinSuccess: 'Vidéos jointes avec succès !',
        joinError: 'Vous avez besoin d\'au moins deux vidéos pour les joindre.',
        logout: 'Se déconnecter',
        cleanupSuccess: 'Nettoyage effectué avec succès.',
        cleanupError: 'Erreur lors du nettoyage.',
        logoutError: 'Erreur lors de la déconnexion.',
        errorJoinVideos: 'Erreur lors de la jonction des vidéos.',
        audioError: 'Erreur lors de la lecture de l\'audio.',
        audioUnsupported: 'Votre navigateur ne prend pas en charge l\'élément audio.',
        encodingNotSupported: 'Encodage non pris en charge :',
        fallbackUtf8: 'utilisation de UTF-8 par défaut.',
        errorDetectSubtitleLanguage: 'Erreur lors de la détection de la langue du sous-titre.',
        uploadVideoError: 'Veuillez télécharger la vidéo avant de l\'envoyer.',
        uploadSubtitleError: 'Veuillez télécharger le sous-titre avant de l\'envoyer.',
        errorCorrectSubtitles: 'Erreur lors de la correction des sous-titres.',
        errorCutSubtitle: 'Erreur lors de la découpe ou du décodage des sous-titres.',
        uploadError: 'Erreur lors de l\'envoi et de la découpe de la vidéo.',
        uploadErrorStatus: 'La taille du fichier de {file.size} Mo dépasse la limite de téléchargement. Le serveur a répondu avec le statut : {status}',
        uploadErrorConnection: 'Impossible de se connecter au serveur. Veuillez vérifier votre réseau et réessayer.',
        uploadErrorMessage: 'Une erreur inattendue s\'est produite : {message}',
        dailyLimitExceeded: 'Limite quotidien de téléversements dépassé. Limite : {dailyLimit}',
        fileSizeExceeded: 'La taille du fichier de {fileSize} MB dépasse la taille maximale autorisée de {maxFileSize} MB.',
        insufficientStorage: 'Stockage insuffisant. Disponible : {availableStorage} GB.',
        unexpectedError: 'Une erreur inattendue est survenue : {message}',
        connectionError: 'Impossible de se connecter au serveur. Veuillez vérifier votre réseau.',
        feedbackTitle: "Nous apprécions vos commentaires !",
        feedbackPlaceholder: "Écrivez vos commentaires ici...",
        feedbackSubmitted: "Commentaires envoyés !",
        feedbackSent: "Commentaires envoyés !",
        sendFeedback: "Envoyer des Commentaires"
    },
    de: {
        welcomeMessage: "🎬 Willkommen bei Vision AI Stream, {username}!",
        tagline: "🚀 Schneiden, bearbeiten, zusammenfügen und zum Strahlen bringen – mit VisionAI haben Sie das Kommando!",
        upgradePlan: "Plan upgraden",
        uploadVideo: 'Video Hochladen',
        uploadSubtitle: 'Untertitel Hochladen',
        transcribe: 'Transkribieren',
        embed: 'Einbetten',
        dubbing: 'Synchronisieren',
        join: 'Zusammenfügen',
        cut: 'Schneiden',
        voiceClone: 'Stimmenklon',
        lipMovement: 'Lippenbewegung',
        lipEnhance: 'Lippenverbesserung',
        startTime: 'Startzeit',
        endTime: 'Endzeit',
        inputLanguage: 'Eingabesprache',
        outputLanguage: 'Ausgabesprache',
        page: "Seite",
        transitionRatioLabel: "Übergangsverhältnis",
        transitionRatioTooltip: "Legt fest, wie lange jeder Untertitel angezeigt wird. Höher = länger sichtbar, Niedriger = schnellere Wechsel.",
        transitionRatioImageTooltip: "Die Dauer des generierten Videos beträgt etwa {seconds} Sekunden.",
        dialoguePlaceholder: "Geben Sie nur ein Stichwort ein, um den Dialog oder das Thema zu schneiden",
        imagePromptPlaceholder: "Beschreiben Sie, was in diesem Bild passieren soll",
        cutOriginalVideo: 'Originalvideo schneiden',
        cutSuccess: 'Schnitt erfolgreich abgeschlossen!',
        downloadCutVideo: 'Geschnittenes Video herunterladen',
        downloadCutSubtitle: 'Geschnittenen Untertitel herunterladen',
        processVideo: 'Video Verarbeiten',
        cutVideoByDialogue: 'Video nach Dialog schneiden',
        cutVideoBySubtitle: 'Video nach Untertitel schneiden',
        uploadSuccess: 'Video erfolgreich verarbeitet!',
        joinVideos: 'Videos Zusammenfügen',
        joinSuccess: 'Videos erfolgreich zusammengefügt!',
        joinError: 'Sie benötigen mindestens zwei Videos zum Zusammenfügen.',
        logout: 'Abmelden',
        cleanupSuccess: 'Aufräumen erfolgreich durchgeführt.',
        cleanupError: 'Fehler beim Aufräumen.',
        logoutError: 'Fehler beim Abmelden.',
        errorJoinVideos: 'Fehler beim Zusammenfügen der Videos.',
        audioError: 'Audio konnte nicht abgespielt werden.',
        audioUnsupported: 'Ihr Browser unterstützt das Audioelement nicht.',
        encodingNotSupported: 'Kodierung wird nicht unterstützt:',
        fallbackUtf8: 'Verwendung von UTF-8 als Ersatz.',
        errorDetectSubtitleLanguage: 'Fehler bei der Erkennung der Untertitelsprache.',
        uploadVideoError: 'Bitte laden Sie das Video hoch, bevor Sie es senden.',
        uploadSubtitleError: 'Bitte laden Sie den Untertitel hoch, bevor Sie ihn senden.',
        errorCorrectSubtitles: 'Fehler beim Korrigieren der Untertitel.',
        errorCutSubtitle: 'Fehler beim Decodieren oder Schneiden des Untertitels.',
        uploadError: 'Fehler beim Hochladen und Schneiden des Videos.',
        uploadErrorStatus: 'Die Dateigröße von {file.size} MB überschreitet das Upload-Limit. Der Server antwortete mit Status: {status}',
        uploadErrorConnection: 'Verbindung zum Server konnte nicht hergestellt werden. Bitte überprüfen Sie Ihr Netzwerk und versuchen Sie es erneut.',
        uploadErrorMessage: 'Ein unerwarteter Fehler ist aufgetreten: {message}',
        dailyLimitExceeded: 'Tägliches Upload-Limit überschritten. Limit: {dailyLimit}',
        fileSizeExceeded: 'Die Dateigröße von {fileSize} MB überschreitet die maximal zulässige Größe von {maxFileSize} MB.',
        insufficientStorage: 'Unzureichender Speicherplatz. Verfügbar: {availableStorage} GB.',
        unexpectedError: 'Ein unerwarteter Fehler ist aufgetreten: {message}',
        connectionError: 'Verbindung zum Server konnte nicht hergestellt werden. Bitte überprüfen Sie Ihr Netzwerk.',
        feedbackTitle: "Wir schätzen Ihr Feedback!",
        feedbackPlaceholder: "Schreiben Sie hier Ihr Feedback...",
        feedbackSubmitted: "Feedback gesendet!",
        feedbackSent: "Feedback gesendet!",
        sendFeedback: "Feedback senden"
    },
    it: {
        welcomeMessage: "🎬 Benvenuto su Vision AI Stream, {username}!",
        tagline: "🚀 Taglia, modifica, unisci e fai brillare – con VisionAI, sei al comando!",
        upgradePlan: "Aggiorna piano",
        uploadVideo: 'Carica Video',
        uploadSubtitle: 'Carica Sottotitolo',
        transcribe: 'Trascrivere',
        embed: 'Incorporare',
        dubbing: 'Doppiaggio',
        join: 'Unire',
        cut: 'Tagliare',
        voiceClone: 'Clonare Voce',
        lipMovement: 'Movimento Labbiale',
        lipEnhance: 'Migliorare Labbra',
        startTime: 'Ora di Inizio',
        endTime: 'Ora di Fine',
        inputLanguage: 'Lingua di Ingresso',
        outputLanguage: 'Lingua di Uscita',
        page: "Pagina",
        transitionRatioLabel: "Fattore di Transizione",
        transitionRatioTooltip: "Imposta quanto tempo ogni sottotitolo rimane a schermo. Maggiore = rimane più a lungo, Minore = cambio più veloce.",
        transitionRatioImageTooltip: "La durata del video generato sarà di circa {seconds} secondi.",
        dialoguePlaceholder: "Inserisci solo una parola chiave per tagliare il dialogo o l'argomento",
        imagePromptPlaceholder: "Descrivi cosa dovrebbe accadere in questa immagine",
        cutOriginalVideo: 'Taglia Video Originale',
        cutSuccess: 'Taglio completato con successo!',
        downloadCutVideo: 'Scarica Video Tagliato',
        downloadCutSubtitle: 'Scarica Sottotitolo Tagliato',
        processVideo: 'Elabora Video',
        cutVideoByDialogue: 'Taglia Video per Dialogo',
        cutVideoBySubtitle: 'Taglia Video per Sottotitolo',
        uploadSuccess: 'Video elaborato con successo!',
        joinVideos: 'Unire Video',
        joinSuccess: 'Video uniti con successo!',
        joinError: 'Devi avere almeno due video per unirli.',
        logout: 'Disconnetti',
        cleanupSuccess: 'Pulizia completata con successo.',
        cleanupError: 'Errore durante la pulizia.',
        logoutError: 'Errore durante la disconnessione.',
        errorJoinVideos: 'Errore durante l\'unione dei video.',
        audioError: 'Impossibile riprodurre l\'audio.',
        audioUnsupported: 'Il tuo browser non supporta l\'elemento audio.',
        encodingNotSupported: 'Codifica non supportata:',
        fallbackUtf8: 'utilizzo UTF-8 come fallback.',
        errorDetectSubtitleLanguage: 'Errore nel rilevamento della lingua dei sottotitoli.',
        uploadVideoError: 'Per favore, carica il video prima di inviarlo.',
        uploadSubtitleError: 'Per favore, carica il sottotitolo prima di inviarlo.',
        errorCorrectSubtitles: 'Errore nella correzione dei sottotitoli.',
        errorCutSubtitle: 'Errore nel decodificare o tagliare il sottotitolo.',
        uploadError: 'Errore nel caricare e tagliare il video.',
        uploadErrorStatus: 'La dimensione del file di {file.size} MB supera il limite di caricamento. Il server ha risposto con lo stato: {status}',
        uploadErrorConnection: 'Impossibile connettersi al server. Controlla la tua connessione di rete e riprova.',
        uploadErrorMessage: 'Si è verificato un errore inaspettato: {message}',
        dailyLimitExceeded: 'Limite di caricamenti giornalieri superato. Limite: {dailyLimit}',
        fileSizeExceeded: 'La dimensione del file di {fileSize} MB supera la dimensione massima consentita di {maxFileSize} MB.',
        insufficientStorage: 'Spazio di archiviazione insufficiente. Disponibile: {availableStorage} GB.',
        unexpectedError: 'Si è verificato un errore imprevisto: {message}',
        connectionError: 'Impossibile connettersi al server. Controlla la tua rete.',
        feedbackTitle: "Apprezziamo il tuo feedback!",
        feedbackPlaceholder: "Scrivi qui il tuo feedback...",
        feedbackSubmitted: "Feedback inviato!",
        feedbackSent: "Feedback inviato!",
        sendFeedback: "Invia Feedback"
    },
    ru: {
        welcomeMessage: "🎬 Добро пожаловать в Vision AI Stream, {username}!",
        tagline: "🚀 Режьте, редактируйте, объединяйте и делайте лучше – с VisionAI вы управляете!",
        upgradePlan: "Обновить план",
        uploadVideo: 'Загрузить Видео',
        uploadSubtitle: 'Загрузить Субтитры',
        transcribe: 'Транскрибировать',
        embed: 'Встроить',
        dubbing: 'Дубляж',
        join: 'Объединить',
        cut: 'Обрезать',
        voiceClone: 'Клон Голоса',
        lipMovement: 'Движение Губ',
        lipEnhance: 'Улучшить Губы',
        startTime: 'Время Начала',
        endTime: 'Время Окончания',
        inputLanguage: 'Язык Входа',
        outputLanguage: 'Язык Выхода',
        page: "Страница",
        transitionRatioLabel: "Коэффициент перехода",
        transitionRatioTooltip: "Определяет, сколько времени каждый субтитр остаётся на экране. Больше = дольше, Меньше = быстрее сменяется.",
        transitionRatioImageTooltip: "Продолжительность сгенерированного видео составит примерно {seconds} секунд.",
        dialoguePlaceholder: "Введите только одно ключевое слово, чтобы вырезать диалог или тему",
        imagePromptPlaceholder: "Опишите, что должно произойти на этом изображении",
        cutOriginalVideo: 'Обрезать Оригинальное Видео',
        cutSuccess: 'Обрезка успешно завершена!',
        downloadCutVideo: 'Скачать Обрезанное Видео',
        downloadCutSubtitle: 'Скачать Обрезанные Субтитры',
        processVideo: 'Обработать Видео',
        cutVideoByDialogue: 'Обрезать Видео по Диалогу',
        cutVideoBySubtitle: 'Обрезать Видео по Субтитрам',
        uploadSuccess: 'Видео успешно обработано!',
        joinVideos: 'Объединить Видео',
        joinSuccess: 'Видео успешно объединены!',
        joinError: 'Необходимо минимум два видео для объединения.',
        logout: 'Выйти',
        cleanupSuccess: 'Очистка успешно выполнена.',
        cleanupError: 'Ошибка при очистке.',
        logoutError: 'Ошибка при выходе.',
        errorJoinVideos: 'Ошибка при объединении видео.',
        audioError: 'Не удалось воспроизвести аудио.',
        audioUnsupported: 'Ваш браузер не поддерживает элемент аудио.',
        encodingNotSupported: 'Кодировка не поддерживается:',
        fallbackUtf8: 'используется UTF-8 как резерв.',
        errorDetectSubtitleLanguage: 'Ошибка при определении языка субтитров.',
        uploadVideoError: 'Пожалуйста, загрузите видео перед отправкой.',
        uploadSubtitleError: 'Пожалуйста, загрузите субтитры перед отправкой.',
        errorCorrectSubtitles: 'Ошибка при корректировке субтитров.',
        errorCutSubtitle: 'Ошибка при декодировании или обрезке субтитров.',
        uploadError: 'Ошибка при загрузке и обрезке видео.',
        uploadErrorStatus: 'Размер файла {file.size} МБ превышает лимит загрузки. Сервер ответил со статусом: {status}',
        uploadErrorConnection: 'Не удалось подключиться к серверу. Проверьте подключение к сети и попробуйте снова.',
        uploadErrorMessage: 'Произошла непредвиденная ошибка: {message}',
        dailyLimitExceeded: 'Превышен дневной лимит загрузок. Лимит: {dailyLimit}',
        fileSizeExceeded: 'Размер файла {fileSize} MB превышает максимально допустимый размер {maxFileSize} MB.',
        insufficientStorage: 'Недостаточно места для хранения. Доступно: {availableStorage} GB.',
        unexpectedError: 'Произошла неожиданная ошибка: {message}',
        connectionError: 'Не удалось подключиться к серверу. Проверьте ваше сетевое подключение.',
        feedbackTitle: "Мы ценим ваш отзыв!",
        feedbackPlaceholder: "Напишите свой отзыв здесь...",
        feedbackSubmitted: "Отзыв отправлен!",
        feedbackSent: "Отзыв отправлен!",
        sendFeedback: "Отправить отзыв"
    },
    zh: {
        welcomeMessage: "🎬 欢迎来到 Vision AI Stream, {username}！",
        tagline: "🚀 剪辑、编辑、合并并让它闪耀——在 VisionAI，一切由你掌控！",
        upgradePlan: "升级计划",
        uploadVideo: '上传视频',
        uploadSubtitle: '上传字幕',
        transcribe: '转录',
        embed: '嵌入',
        dubbing: '配音',
        join: '合并',
        cut: '剪辑',
        voiceClone: '语音克隆',
        lipMovement: '唇部动作',
        lipEnhance: '增强唇部',
        startTime: '开始时间',
        endTime: '结束时间',
        inputLanguage: '输入语言',
        outputLanguage: '输出语言',
        page: "页面",
        transitionRatioLabel: "过渡比率",
        transitionRatioTooltip: "设置每条字幕在屏幕上显示的时长。数值越大 = 停留更久，数值越小 = 切换更快。",
        transitionRatioImageTooltip: "生成的视频时长约为 {seconds} 秒。",
        dialoguePlaceholder: "只输入一个关键词来剪辑对话或主题",
        imagePromptPlaceholder: "描述这张图片中应发生的事情",
        cutOriginalVideo: '剪辑原视频',
        cutSuccess: '剪辑成功完成！',
        downloadCutVideo: '下载剪辑视频',
        downloadCutSubtitle: '下载剪辑字幕',
        processVideo: '处理视频',
        cutVideoByDialogue: '按对话剪辑视频',
        cutVideoBySubtitle: '按字幕剪辑视频',
        uploadSuccess: '视频处理成功！',
        joinVideos: '合并视频',
        joinSuccess: '视频成功合并！',
        joinError: '需要至少两个视频才能合并。',
        logout: '登出',
        cleanupSuccess: '清理成功完成。',
        cleanupError: '清理时出错。',
        logoutError: '登出时出错。',
        errorJoinVideos: '合并视频时出错。',
        audioError: '无法播放音频。',
        audioUnsupported: '您的浏览器不支持音频元素。',
        encodingNotSupported: '不支持的编码：',
        fallbackUtf8: '使用 UTF-8 作为后备。',
        errorDetectSubtitleLanguage: '检测字幕语言时出错。',
        uploadVideoError: '请先上传视频再发送。',
        uploadSubtitleError: '请先上传字幕再发送。',
        errorCorrectSubtitles: '更正字幕时出错。',
        errorCutSubtitle: '解码或剪辑字幕时出错。',
        uploadError: '上传和剪辑视频时出错。',
        uploadErrorStatus: '文件大小 {file.size} MB 超过了上传限制。服务器响应状态为：{status}',
        uploadErrorConnection: '无法连接到服务器。请检查您的网络，然后重试。',
        uploadErrorMessage: '发生意外错误：{message}',
        dailyLimitExceeded: '超出每日上传限制。限制：{dailyLimit}',
        fileSizeExceeded: '文件大小 {fileSize} MB 超过允许的最大大小 {maxFileSize} MB。',
        insufficientStorage: '存储空间不足。可用：{availableStorage} GB。',
        unexpectedError: '发生意外错误：{message}',
        connectionError: '无法连接到服务器。请检查您的网络。',
        feedbackTitle: "我们重视您的反馈！",
        feedbackPlaceholder: "在这里写下您的反馈...",
        feedbackSubmitted: "反馈已提交！",
        feedbackSent: "反馈已发送！",
        sendFeedback: "发送反馈"
    },
    ja: {
        welcomeMessage: "🎬 Vision AI Stream へようこそ, {username}!",
        tagline: "🚀 カット、編集、結合、輝きを加える – VisionAI であなたが指揮をとる！",
        upgradePlan: "プランをアップグレード",
        uploadVideo: 'ビデオをアップロード',
        uploadSubtitle: '字幕をアップロード',
        transcribe: '文字起こし',
        embed: '埋め込む',
        dubbing: '吹き替え',
        join: '結合',
        cut: 'カット',
        voiceClone: '声のクローン',
        lipMovement: '唇の動き',
        lipEnhance: '唇を強調',
        startTime: '開始時間',
        endTime: '終了時間',
        inputLanguage: '入力言語',
        outputLanguage: '出力言語',
        page: "ページ",
        transitionRatioLabel: "トランジション比率",
        transitionRatioTooltip: "各字幕を表示する時間を設定します。値が大きいほど長く表示され、小さいほど早く切り替わります。",
        transitionRatioImageTooltip: "生成されるビデオの長さは約 {seconds} 秒です。",
        dialoguePlaceholder: "対話やトピックをカットするにはキーワードを1つだけ入力してください",
        imagePromptPlaceholder: "この画像で何が起こるべきかを説明してください",
        cutOriginalVideo: 'オリジナルビデオをカット',
        cutSuccess: 'カットが正常に完了しました！',
        downloadCutVideo: 'カットしたビデオをダウンロード',
        downloadCutSubtitle: 'カットした字幕をダウンロード',
        processVideo: 'ビデオを処理',
        cutVideoByDialogue: 'ダイアログでビデオをカット',
        cutVideoBySubtitle: '字幕でビデオをカット',
        uploadSuccess: 'ビデオが正常に処理されました！',
        joinVideos: 'ビデオを結合',
        joinSuccess: 'ビデオが正常に結合されました！',
        joinError: '結合するには、少なくとも2つのビデオが必要です。',
        logout: 'ログアウト',
        cleanupSuccess: 'クリーンアップが正常に完了しました。',
        cleanupError: 'クリーンアップ中にエラーが発生しました。',
        logoutError: 'ログアウト中にエラーが発生しました。',
        errorJoinVideos: 'ビデオの結合中にエラーが発生しました。',
        audioError: 'オーディオの再生に失敗しました。',
        audioUnsupported: 'お使いのブラウザはオーディオ要素をサポートしていません。',
        encodingNotSupported: 'サポートされていないエンコード：',
        fallbackUtf8: 'UTF-8をフォールバックとして使用します。',
        errorDetectSubtitleLanguage: '字幕の言語を検出中にエラーが発生しました。',
        uploadVideoError: '送信する前にビデオをアップロードしてください。',
        uploadSubtitleError: '送信する前に字幕をアップロードしてください。',
        errorCorrectSubtitles: '字幕を修正中にエラーが発生しました。',
        errorCutSubtitle: '字幕のデコードまたはカット中にエラーが発生しました。',
        uploadError: 'ビデオのアップロードおよびカット中にエラーが発生しました。',
        uploadErrorStatus: 'ファイルサイズ {file.size} MB はアップロード制限を超えています。サーバーはステータス {status} で応答しました',
        uploadErrorConnection: 'サーバーに接続できませんでした。ネットワークを確認して再試行してください。',
        uploadErrorMessage: '予期しないエラーが発生しました：{message}',
        dailyLimitExceeded: '1日のアップロード制限を超えました。制限：{dailyLimit}',
        fileSizeExceeded: 'ファイルサイズ {fileSize} MB は許容最大サイズ {maxFileSize} MB を超えています。',
        insufficientStorage: 'ストレージが不足しています。利用可能：{availableStorage} GB。',
        unexpectedError: '予期しないエラーが発生しました：{message}',
        connectionError: 'サーバーに接続できませんでした。ネットワークを確認してください。',
        feedbackTitle: "フィードバックを大切にしています！",
        feedbackPlaceholder: "ここにフィードバックを書いてください...",
        feedbackSubmitted: "フィードバックが送信されました！",
        feedbackSent: "フィードバックが送信されました！",
        sendFeedback: "フィードバックを送信"
    },
    ko: {
        welcomeMessage: "🎬 Vision AI Stream에 오신 것을 환영합니다, {username}!",
        tagline: "🚀 자르고, 편집하고, 합치고, 빛나게 – VisionAI로 당신이 지휘하세요!",
        upgradePlan: "플랜 업그레이드",
        uploadVideo: '비디오 업로드',
        uploadSubtitle: '자막 업로드',
        transcribe: '전사',
        embed: '삽입',
        dubbing: '더빙',
        join: '합치기',
        cut: '자르기',
        voiceClone: '음성 복제',
        lipMovement: '입술 움직임',
        lipEnhance: '입술 강조',
        startTime: '시작 시간',
        endTime: '종료 시간',
        inputLanguage: '입력 언어',
        outputLanguage: '출력 언어',
        page: "페이지",
        transitionRatioLabel: "전환 비율",
        transitionRatioTooltip: "각 자막이 화면에 표시되는 시간을 설정합니다. 값이 클수록 오래, 작을수록 빠르게 바뀝니다.",
        transitionRatioImageTooltip: "생성된 비디오의 길이는 약 {seconds}초입니다.",
        dialoguePlaceholder: "대화나 주제를 자르려면 하나의 키워드만 입력하세요",
        imagePromptPlaceholder: "이 이미지에서 어떤 일이 일어나야 하는지 설명하세요",
        cutOriginalVideo: '원본 비디오 자르기',
        cutSuccess: '성공적으로 자르기 완료!',
        downloadCutVideo: '잘린 비디오 다운로드',
        downloadCutSubtitle: '잘린 자막 다운로드',
        processVideo: '비디오 처리',
        cutVideoByDialogue: '대화로 비디오 자르기',
        cutVideoBySubtitle: '자막으로 비디오 자르기',
        uploadSuccess: '비디오가 성공적으로 처리되었습니다!',
        joinVideos: '비디오 합치기',
        joinSuccess: '비디오가 성공적으로 합쳐졌습니다!',
        joinError: '합치려면 최소 두 개의 비디오가 필요합니다.',
        logout: '로그아웃',
        cleanupSuccess: '정리 성공적으로 완료.',
        cleanupError: '정리 중 오류 발생.',
        logoutError: '로그아웃 중 오류 발생.',
        errorJoinVideos: '비디오 합치는 중 오류 발생.',
        audioError: '오디오 재생 실패.',
        audioUnsupported: '브라우저에서 오디오 요소를 지원하지 않습니다.',
        encodingNotSupported: '지원되지 않는 인코딩:',
        fallbackUtf8: 'UTF-8을 기본으로 사용.',
        errorDetectSubtitleLanguage: '자막 언어 감지 중 오류 발생.',
        uploadVideoError: '비디오를 업로드한 후 전송하세요.',
        uploadSubtitleError: '자막을 업로드한 후 전송하세요.',
        errorCorrectSubtitles: '자막 수정 중 오류 발생.',
        errorCutSubtitle: '자막 해독 또는 자르기 중 오류 발생.',
        uploadError: '비디오 업로드 및 자르기 중 오류 발생.',
        uploadErrorStatus: '파일 크기 {file.size}MB가 업로드 제한을 초과했습니다. 서버가 {status} 상태로 응답했습니다',
        uploadErrorConnection: '서버에 연결할 수 없습니다. 네트워크를 확인하고 다시 시도하십시오.',
        uploadErrorMessage: '예기치 않은 오류가 발생했습니다: {message}',
        dailyLimitExceeded: '일일 업로드 한도를 초과했습니다. 한도: {dailyLimit}',
        fileSizeExceeded: '파일 크기 {fileSize}MB가 허용된 최대 크기 {maxFileSize}MB를 초과했습니다.',
        insufficientStorage: '저장 공간이 부족합니다. 사용 가능: {availableStorage}GB.',
        unexpectedError: '예기치 않은 오류가 발생했습니다: {message}',
        connectionError: '서버에 연결할 수 없습니다. 네트워크를 확인하세요.',
        feedbackTitle: "소중한 피드백을 환영합니다!",
        feedbackPlaceholder: "여기에 피드백을 작성하세요...",
        feedbackSubmitted: "피드백이 제출되었습니다!",
        feedbackSent: "피드백이 전송되었습니다!",
        sendFeedback: "피드백 보내기"
    },
    hi: {
        welcomeMessage: "🎬 Vision AI Stream में आपका स्वागत है, {username}!",
        tagline: "🚀 काटें, संपादित करें, जोड़ें और इसे चमकाएं – VisionAI के साथ, आप नियंत्रण में हैं!",
        upgradePlan: "योजना को अपग्रेड करें",
        uploadVideo: 'वीडियो अपलोड करें',
        uploadSubtitle: 'उपशीर्षक अपलोड करें',
        transcribe: 'लिप्यंतरण करें',
        embed: 'एम्बेड करें',
        dubbing: 'डबिंग',
        join: 'जोड़ें',
        cut: 'काटें',
        voiceClone: 'आवाज़ क्लोन',
        lipMovement: 'होठों की गति',
        lipEnhance: 'होठों को सुधारें',
        startTime: 'प्रारंभ समय',
        endTime: 'समाप्ति समय',
        inputLanguage: 'इनपुट भाषा',
        outputLanguage: 'आउटपुट भाषा',
        page: "पेज",
        transitionRatioLabel: "ट्रांज़िशन अनुपात",
        transitionRatioTooltip: "प्रत्येक उपशीर्षक कितनी देर तक दिखेगा तय करता है। बड़ा मान = ज़्यादा देर, छोटा मान = तेज़ी से बदलेगा।",
        transitionRatioImageTooltip: "उत्पन्न वीडियो की अवधि लगभग {seconds} सेकंड होगी।",
        dialoguePlaceholder: "संवाद या विषय काटने के लिए केवल एक कीवर्ड दर्ज करें",
        imagePromptPlaceholder: "इस छवि में क्या होना चाहिए, इसका वर्णन करें",
        cutOriginalVideo: 'मूल वीडियो काटें',
        cutSuccess: 'काटने का कार्य सफलतापूर्वक पूरा हुआ!',
        downloadCutVideo: 'कटा हुआ वीडियो डाउनलोड करें',
        downloadCutSubtitle: 'कटा हुआ उपशीर्षक डाउनलोड करें',
        processVideo: 'वीडियो प्रक्रिया',
        cutVideoByDialogue: 'संवाद द्वारा वीडियो काटें',
        cutVideoBySubtitle: 'उपशीर्षक द्वारा वीडियो काटें',
        uploadSuccess: 'वीडियो सफलतापूर्वक प्रोसेस किया गया!',
        joinVideos: 'वीडियो जोड़ें',
        joinSuccess: 'वीडियो सफलतापूर्वक जोड़े गए!',
        joinError: 'जोड़ने के लिए कम से कम दो वीडियो आवश्यक हैं।',
        logout: 'लॉगआउट',
        cleanupSuccess: 'सफाई सफलतापूर्वक की गई।',
        cleanupError: 'सफाई के दौरान त्रुटि।',
        logoutError: 'लॉगआउट में त्रुटि।',
        errorJoinVideos: 'वीडियो जोड़ने में त्रुटि।',
        audioError: 'ऑडियो प्लेबैक विफल रहा।',
        audioUnsupported: 'आपका ब्राउज़र ऑडियो तत्व का समर्थन नहीं करता।',
        encodingNotSupported: 'समर्थित नहीं किया गया एन्कोडिंग:',
        fallbackUtf8: 'यूटीएफ-8 के रूप में वापस जा रहा है।',
        errorDetectSubtitleLanguage: 'उपशीर्षक भाषा का पता लगाने में त्रुटि।',
        uploadVideoError: 'कृपया वीडियो अपलोड करें और फिर भेजें।',
        uploadSubtitleError: 'कृपया उपशीर्षक अपलोड करें और फिर भेजें।',
        errorCorrectSubtitles: 'उपशीर्षकों को सही करने में त्रुटि।',
        errorCutSubtitle: 'उपशीर्षक को डिकोड या काटने में त्रुटि।',
        uploadError: 'वीडियो अपलोड और काटने में त्रुटि।',
        uploadErrorStatus: '{file.size} एमबी का फ़ाइल आकार अपलोड सीमा से अधिक है। सर्वर ने स्थिति {status} के साथ प्रतिक्रिया दी',
        uploadErrorConnection: 'सर्वर से कनेक्ट नहीं हो सका। कृपया अपना नेटवर्क जांचें और पुनः प्रयास करें।',
        uploadErrorMessage: 'एक अप्रत्याशित त्रुटि हुई: {message}',
        dailyLimitExceeded: 'दैनिक अपलोड सीमा पार हो गई है। सीमा: {dailyLimit}',
        fileSizeExceeded: 'फ़ाइल का आकार {fileSize}MB अनुमत अधिकतम आकार {maxFileSize}MB से अधिक है।',
        insufficientStorage: 'पर्याप्त संग्रहण उपलब्ध नहीं है। उपलब्ध: {availableStorage}GB।',
        unexpectedError: 'एक अप्रत्याशित त्रुटि हुई: {message}',
        connectionError: 'सर्वर से कनेक्ट नहीं हो सका। कृपया अपना नेटवर्क जांचें।',
        feedbackTitle: "हम आपके फीडबैक की सराहना करते हैं!",
        feedbackPlaceholder: "यहां अपना फीडबैक लिखें...",
        feedbackSubmitted: "फीडबैक भेजा गया!",
        feedbackSent: "फीडबैक भेजा गया!",
        sendFeedback: "फीडबैक भेजें"
    },
    ar: {
        welcomeMessage: "🎬 مرحبًا بك في Vision AI Stream، {username}!",
        tagline: "🚀 قص، حرر، اجمع واجعلها تتألق – مع VisionAI، أنت المسؤول!",
        upgradePlan: "ترقية الخطة",
        uploadVideo: 'رفع الفيديو',
        uploadSubtitle: 'رفع الترجمة',
        transcribe: 'نسخ',
        embed: 'تضمين',
        dubbing: 'الدبلجة',
        join: 'دمج',
        cut: 'قص',
        voiceClone: 'استنساخ الصوت',
        lipMovement: 'حركة الشفاه',
        lipEnhance: 'تعزيز الشفاه',
        startTime: 'وقت البدء',
        endTime: 'وقت النهاية',
        inputLanguage: 'لغة الإدخال',
        outputLanguage: 'لغة الإخراج',
        page: "صفحة",
        transitionRatioLabel: "نسبة الانتقال",
        transitionRatioTooltip: "يحدد مدة بقاء كل ترجمة على الشاشة. أكبر = مدة أطول، أصغر = تبديل أسرع.",
        transitionRatioImageTooltip: "ستكون مدة الفيديو المُنتج حوالي {seconds} ثانية.",
        dialoguePlaceholder: "أدخل كلمة مفتاحية واحدة فقط لقص الحوار أو الموضوع",
        imagePromptPlaceholder: "صف ما يجب أن يحدث في هذه الصورة",
        cutOriginalVideo: 'قص الفيديو الأصلي',
        cutSuccess: 'تم القص بنجاح!',
        downloadCutVideo: 'تحميل الفيديو المقصوص',
        downloadCutSubtitle: 'تحميل الترجمة المقصوصة',
        processVideo: 'معالجة الفيديو',
        cutVideoByDialogue: 'قص الفيديو بالحوار',
        cutVideoBySubtitle: 'قص الفيديو بالترجمة',
        uploadSuccess: 'تمت معالجة الفيديو بنجاح!',
        joinVideos: 'دمج الفيديوهات',
        joinSuccess: 'تم دمج الفيديوهات بنجاح!',
        joinError: 'تحتاج إلى فيديوهين على الأقل للدمج.',
        logout: 'تسجيل الخروج',
        cleanupSuccess: 'تم التنظيف بنجاح.',
        cleanupError: 'خطأ أثناء التنظيف.',
        logoutError: 'خطأ أثناء تسجيل الخروج.',
        errorJoinVideos: 'خطأ أثناء دمج الفيديوهات.',
        audioError: 'فشل في تشغيل الصوت.',
        audioUnsupported: 'المتصفح لا يدعم عنصر الصوت.',
        encodingNotSupported: 'الترميز غير مدعوم:',
        fallbackUtf8: 'الرجوع إلى UTF-8.',
        errorDetectSubtitleLanguage: 'خطأ في اكتشاف لغة الترجمة.',
        uploadVideoError: 'يرجى تحميل الفيديو قبل الإرسال.',
        uploadSubtitleError: 'يرجى تحميل الترجمة قبل الإرسال.',
        errorCorrectSubtitles: 'خطأ في تصحيح الترجمة.',
        errorCutSubtitle: 'خطأ في فك تشفير أو قص الترجمة.',
        uploadError: 'خطأ أثناء تحميل وقص الفيديو.',
        uploadErrorStatus: 'حجم الملف {file.size} ميجابايت يتجاوز حد التحميل. رد الخادم بالحالة: {status}',
        uploadErrorConnection: 'تعذر الاتصال بالخادم. يرجى التحقق من الشبكة والمحاولة مرة أخرى.',
        uploadErrorMessage: 'حدث خطأ غير متوقع: {message}',
        dailyLimitExceeded: 'تم تجاوز الحد اليومي للتحميلات. الحد: {dailyLimit}',
        fileSizeExceeded: 'حجم الملف {fileSize}MB يتجاوز الحجم المسموح به {maxFileSize}MB.',
        insufficientStorage: 'لا توجد مساحة تخزين كافية. المتاح: {availableStorage}GB.',
        unexpectedError: 'حدث خطأ غير متوقع: {message}',
        connectionError: 'تعذر الاتصال بالخادم. يرجى التحقق من الشبكة.',
        feedbackTitle: "نحن نقدر ملاحظاتك!",
        feedbackPlaceholder: "اكتب ملاحظاتك هنا...",
        feedbackSubmitted: "تم إرسال الملاحظات!",
        feedbackSent: "تم إرسال الملاحظات!",
        sendFeedback: "إرسال الملاحظات"
    },
    tr: {
        welcomeMessage: "🎬 Vision AI Stream'a hoş geldiniz, {username}!",
        tagline: "🚀 Kes, düzenle, birleştir ve parlat – VisionAI ile kontrol sizde!",
        upgradePlan: "Planı Yükselt",
        uploadVideo: 'Video Yükle',
        uploadSubtitle: 'Altyazı Yükle',
        transcribe: 'Yazıya Çevir',
        embed: 'Göm',
        dubbing: 'Dublaj',
        join: 'Birleştir',
        cut: 'Kes',
        voiceClone: 'Ses Klonlama',
        lipMovement: 'Dudak Hareketi',
        lipEnhance: 'Dudak Geliştirme',
        startTime: 'Başlangıç Zamanı',
        endTime: 'Bitiş Zamanı',
        inputLanguage: 'Giriş Dili',
        outputLanguage: 'Çıkış Dili',
        page: "Sayfa",
        transitionRatioLabel: "Geçiş Oranı",
        transitionRatioTooltip: "Her altyazının ekranda ne kadar kalacağını belirler. Yüksek = daha uzun kalır, Düşük = daha hızlı değişir.",
        transitionRatioImageTooltip: "Oluşturulan videonun süresi yaklaşık {seconds} saniye olacaktır.",
        dialoguePlaceholder: "Yalnızca bir anahtar kelime girin ve diyaloğu veya konuyu kesin",
        imagePromptPlaceholder: "Bu görüntüde ne olmalı, tarif edin",
        cutOriginalVideo: 'Orijinal Videoyu Kes',
        cutSuccess: 'Kesme başarıyla tamamlandı!',
        downloadCutVideo: 'Kesilen Videoyu İndir',
        downloadCutSubtitle: 'Kesilen Altyazıyı İndir',
        processVideo: 'Videoyu İşle',
        cutVideoByDialogue: 'Diyaloga Göre Videoyu Kes',
        cutVideoBySubtitle: 'Altyazıya Göre Videoyu Kes',
        uploadSuccess: 'Video başarıyla işlendi!',
        joinVideos: 'Videoları Birleştir',
        joinSuccess: 'Videolar başarıyla birleştirildi!',
        joinError: 'Birleştirmek için en az iki videoya ihtiyacınız var.',
        logout: 'Çıkış Yap',
        cleanupSuccess: 'Temizlik başarıyla gerçekleştirildi.',
        cleanupError: 'Temizlik sırasında hata oluştu.',
        logoutError: 'Çıkış yaparken hata oluştu.',
        errorJoinVideos: 'Videoları birleştirirken hata oluştu.',
        audioError: 'Ses çalma başarısız oldu.',
        audioUnsupported: 'Tarayıcınız ses öğesini desteklemiyor.',
        encodingNotSupported: 'Desteklenmeyen kodlama:',
        fallbackUtf8: 'Yedek olarak UTF-8 kullanılıyor.',
        errorDetectSubtitleLanguage: 'Altyazı dilini algılama hatası.',
        uploadVideoError: 'Göndermeden önce videoyu yükleyin.',
        uploadSubtitleError: 'Göndermeden önce altyazıyı yükleyin.',
        errorCorrectSubtitles: 'Altyazıları düzeltme sırasında hata oluştu.',
        errorCutSubtitle: 'Altyazıyı çözümleme veya kesme sırasında hata oluştu.',
        uploadError: 'Video yükleme ve kesme sırasında hata oluştu.',
        uploadErrorStatus: '{file.size} MB dosya boyutu yükleme sınırını aşıyor. Sunucu {status} durumu ile yanıt verdi',
        uploadErrorConnection: 'Sunucuya bağlanılamadı. Lütfen ağınızı kontrol edin ve tekrar deneyin.',
        uploadErrorMessage: 'Beklenmeyen bir hata oluştu: {message}',
        dailyLimitExceeded: 'Günlük yükleme sınırı aşıldı. Sınır: {dailyLimit}',
        fileSizeExceeded: 'Dosya boyutu {fileSize}MB, izin verilen maksimum boyutu {maxFileSize}MB aşıyor.',
        insufficientStorage: 'Yetersiz depolama alanı. Mevcut: {availableStorage}GB.',
        unexpectedError: 'Beklenmeyen bir hata oluştu: {message}',
        connectionError: 'Sunucuya bağlanılamadı. Lütfen ağınızı kontrol edin.',
        feedbackTitle: "Geri bildiriminize değer veriyoruz!",
        feedbackPlaceholder: "Geri bildiriminizi buraya yazın...",
        feedbackSubmitted: "Geri bildirim gönderildi!",
        feedbackSent: "Geri bildirim gönderildi!",
        sendFeedback: "Geri Bildirim Gönder"
    },
    nl: {
        welcomeMessage: "🎬 Welkom bij Vision AI Stream, {username}!",
        tagline: "🚀 Knippen, bewerken, samenvoegen en laten schitteren – met VisionAI hebt u de leiding!",
        upgradePlan: "Plan upgraden",
        uploadVideo: 'Video Uploaden',
        uploadSubtitle: 'Ondertiteling Uploaden',
        transcribe: 'Transcriberen',
        embed: 'Insluiten',
        dubbing: 'Nasynchronisatie',
        join: 'Samenvoegen',
        cut: 'Knippen',
        voiceClone: 'Stem Klonen',
        lipMovement: 'Lipbeweging',
        lipEnhance: 'Lipversterking',
        startTime: 'Starttijd',
        endTime: 'Eindtijd',
        inputLanguage: 'Invoertaal',
        outputLanguage: 'Uitvoertaal',
        page: "Pagina",
        transitionRatioLabel: "Overgangsratio",
        transitionRatioTooltip: "Bepaalt hoelang elke ondertitel op het scherm blijft. Hoger = langer zichtbaar, Lager = snellere wissel.",
        transitionRatioImageTooltip: "De gegenereerde video duurt ongeveer {seconds} seconden.",
        dialoguePlaceholder: "Voer slechts één trefwoord in om de dialoog of het onderwerp te knippen",
        imagePromptPlaceholder: "Beschrijf wat er op deze afbeelding moet gebeuren",
        cutOriginalVideo: 'Oorspronkelijke Video Knippen',
        cutSuccess: 'Knippen succesvol voltooid!',
        downloadCutVideo: 'Geknipte Video Downloaden',
        downloadCutSubtitle: 'Geknipte Ondertiteling Downloaden',
        processVideo: 'Video Verwerken',
        cutVideoByDialogue: 'Video Knippen per Dialoog',
        cutVideoBySubtitle: 'Video Knippen per Ondertiteling',
        uploadSuccess: 'Video succesvol verwerkt!',
        joinVideos: 'Video’s Samenvoegen',
        joinSuccess: 'Video’s succesvol samengevoegd!',
        joinError: 'Je hebt minstens twee video’s nodig om samen te voegen.',
        logout: 'Uitloggen',
        cleanupSuccess: 'Opruimen succesvol uitgevoerd.',
        cleanupError: 'Fout bij het opruimen.',
        logoutError: 'Fout bij het uitloggen.',
        errorJoinVideos: 'Fout bij het samenvoegen van video’s.',
        audioError: 'Audioweergave mislukt.',
        audioUnsupported: 'Je browser ondersteunt het audio-element niet.',
        encodingNotSupported: 'Codering niet ondersteund:',
        fallbackUtf8: 'gebruik makend van UTF-8 als fallback.',
        errorDetectSubtitleLanguage: 'Fout bij het detecteren van de ondertitelingstaal.',
        uploadVideoError: 'Upload de video voordat je deze verzendt.',
        uploadSubtitleError: 'Upload de ondertiteling voordat je deze verzendt.',
        errorCorrectSubtitles: 'Fout bij het corrigeren van ondertitels.',
        errorCutSubtitle: 'Fout bij het decoderen of knippen van ondertiteling.',
        uploadError: 'Fout bij het uploaden en knippen van de video.',
        uploadErrorStatus: 'De bestandsgrootte van {file.size} MB overschrijdt de uploadlimiet. De server reageerde met status: {status}',
        uploadErrorConnection: 'Kan geen verbinding maken met de server. Controleer uw netwerk en probeer het opnieuw.',
        uploadErrorMessage: 'Er is een onverwachte fout opgetreden: {message}',
        dailyLimitExceeded: 'Dagelijkse uploadlimiet overschreden. Limiet: {dailyLimit}',
        fileSizeExceeded: 'De bestandsgrootte van {fileSize}MB overschrijdt de toegestane maximale grootte van {maxFileSize}MB.',
        insufficientStorage: 'Onvoldoende opslagruimte. Beschikbaar: {availableStorage}GB.',
        unexpectedError: 'Er is een onverwachte fout opgetreden: {message}',
        connectionError: 'Kan geen verbinding maken met de server. Controleer uw netwerk.',
        feedbackTitle: "We waarderen uw feedback!",
        feedbackPlaceholder: "Schrijf hier uw feedback...",
        feedbackSubmitted: "Feedback verzonden!",
        feedbackSent: "Feedback verzonden!",
        sendFeedback: "Feedback verzenden"
    },
    sv: {
        welcomeMessage: "🎬 Välkommen till Vision AI Stream, {username}!",
        tagline: "🚀 Klipp, redigera, slå ihop och låt det glänsa – med VisionAI har du kontrollen!",
        upgradePlan: "Uppgradera planen",
        uploadVideo: 'Ladda upp Video',
        uploadSubtitle: 'Ladda upp Undertext',
        transcribe: 'Transkribera',
        embed: 'Bädda in',
        dubbing: 'Dubba',
        join: 'Slå ihop',
        cut: 'Klipp',
        voiceClone: 'Röstklon',
        lipMovement: 'Läprörelse',
        lipEnhance: 'Förbättra Läppar',
        startTime: 'Starttid',
        endTime: 'Sluttid',
        inputLanguage: 'Indatasspråk',
        outputLanguage: 'Utmatningsspråk',
        page: "Sida",
        transitionRatioLabel: "Övergångsförhållande",
        transitionRatioTooltip: "Anger hur länge varje undertext visas. Högre = syns längre, Lägre = byts snabbare.",
        transitionRatioImageTooltip: "Den genererade videon kommer att vara ungefär {seconds} sekunder lång.",
        dialoguePlaceholder: "Ange bara ett nyckelord för att klippa dialogen eller ämnet",
        imagePromptPlaceholder: "Beskriv vad som ska hända i den här bilden",
        cutOriginalVideo: 'Klipp Originalvideo',
        cutSuccess: 'Klippning framgångsrikt!',
        downloadCutVideo: 'Ladda ner Klippt Video',
        downloadCutSubtitle: 'Ladda ner Klippt Undertext',
        processVideo: 'Bearbeta Video',
        cutVideoByDialogue: 'Klipp Video efter Dialog',
        cutVideoBySubtitle: 'Klipp Video efter Undertext',
        uploadSuccess: 'Videon har bearbetats framgångsrikt!',
        joinVideos: 'Slå ihop Videor',
        joinSuccess: 'Videor har slagits ihop framgångsrikt!',
        joinError: 'Du behöver minst två videor för att slå ihop.',
        logout: 'Logga ut',
        cleanupSuccess: 'Rensning framgångsrikt genomförd.',
        cleanupError: 'Fel vid rensning.',
        logoutError: 'Fel vid utloggning.',
        errorJoinVideos: 'Fel vid ihopslagning av videor.',
        audioError: 'Ljuduppspelning misslyckades.',
        audioUnsupported: 'Din webbläsare stöder inte ljudfunktionen.',
        encodingNotSupported: 'Kodning stöds inte:',
        fallbackUtf8: 'använder UTF-8 som fallback.',
        errorDetectSubtitleLanguage: 'Fel vid upptäckt av undertexts språk.',
        uploadVideoError: 'Ladda upp videon innan du skickar den.',
        uploadSubtitleError: 'Ladda upp undertexten innan du skickar den.',
        errorCorrectSubtitles: 'Fel vid korrigering av undertexter.',
        errorCutSubtitle: 'Fel vid dekodering eller klippning av undertext.',
        uploadError: 'Fel vid uppladdning och klippning av video.',
        uploadErrorStatus: 'Filstorleken på {file.size} MB överskrider uppladdningsgränsen. Servern svarade med status: {status}',
        uploadErrorConnection: 'Det gick inte att ansluta till servern. Kontrollera ditt nätverk och försök igen.',
        uploadErrorMessage: 'Ett oväntat fel uppstod: {message}',
        dailyLimitExceeded: 'Daglig uppladdningsgräns överskriden. Gräns: {dailyLimit}',
        fileSizeExceeded: 'Filstorleken på {fileSize}MB överskrider den maximalt tillåtna storleken på {maxFileSize}MB.',
        insufficientStorage: 'Otillräckligt lagringsutrymme. Tillgängligt: {availableStorage}GB.',
        unexpectedError: 'Ett oväntat fel inträffade: {message}',
        connectionError: 'Det gick inte att ansluta till servern. Kontrollera ditt nätverk.',
        feedbackTitle: "Vi uppskattar din feedback!",
        feedbackPlaceholder: "Skriv din feedback här...",
        feedbackSubmitted: "Feedback skickad!",
        feedbackSent: "Feedback skickad!",
        sendFeedback: "Skicka feedback"
    },
    no: {
        welcomeMessage: "🎬 Velkommen til Vision AI Stream, {username}!",
        tagline: "🚀 Klipp, rediger, slå sammen og få det til å skinne – med VisionAI har du kontrollen!",
        upgradePlan: "Oppgrader plan",
        uploadVideo: 'Last opp Video',
        uploadSubtitle: 'Last opp Undertekst',
        transcribe: 'Transkribere',
        embed: 'Bygg inn',
        dubbing: 'Dubbe',
        join: 'Slå sammen',
        cut: 'Klipp',
        voiceClone: 'Stemmeklon',
        lipMovement: 'Leppebevegelse',
        lipEnhance: 'Forbedre Lepper',
        startTime: 'Starttid',
        endTime: 'Sluttid',
        inputLanguage: 'Innsspråk',
        outputLanguage: 'Utgangsspråk',
        page: "Side",
        transitionRatioLabel: "Overgangsforhold",
        transitionRatioTooltip: "Bestemmer hvor lenge hver undertekst vises. Høyere = lengre, Lavere = raskere bytte.",
        transitionRatioImageTooltip: "Den genererte videoen vil være omtrent {seconds} sekunder lang.",
        dialoguePlaceholder: "Skriv bare inn ett nøkkelord for å klippe dialogen eller emnet",
        imagePromptPlaceholder: "Beskriv hva som skal skje i dette bildet",
        cutOriginalVideo: 'Klipp Originalvideo',
        cutSuccess: 'Klipping fullført!',
        downloadCutVideo: 'Last ned Klippet Video',
        downloadCutSubtitle: 'Last ned Klippet Undertekst',
        processVideo: 'Behandle Video',
        cutVideoByDialogue: 'Klipp Video etter Dialog',
        cutVideoBySubtitle: 'Klipp Video etter Undertekst',
        uploadSuccess: 'Video behandlet med suksess!',
        joinVideos: 'Slå sammen Videoer',
        joinSuccess: 'Videoer ble vellykket sammenslått!',
        joinError: 'Du trenger minst to videoer for å slå sammen.',
        logout: 'Logg ut',
        cleanupSuccess: 'Rydding fullført.',
        cleanupError: 'Feil under rydding.',
        logoutError: 'Feil ved utlogging.',
        errorJoinVideos: 'Feil ved sammenslåing av videoer.',
        audioError: 'Feil ved lydavspilling.',
        audioUnsupported: 'Nettleseren støtter ikke lyd-elementet.',
        encodingNotSupported: 'Koding støttes ikke:',
        fallbackUtf8: 'bruker UTF-8 som fallback.',
        errorDetectSubtitleLanguage: 'Feil ved oppdagelse av undertekstspråk.',
        uploadVideoError: 'Last opp videoen før du sender den.',
        uploadSubtitleError: 'Last opp underteksten før du sender den.',
        errorCorrectSubtitles: 'Feil ved retting av undertekster.',
        errorCutSubtitle: 'Feil ved dekoding eller klipping av undertekster.',
        uploadError: 'Feil ved opplasting og klipping av video.',
        uploadErrorStatus: 'Filstørrelsen på {file.size} MB overskrider opplastingsgrensen. Serveren svarte med status: {status}',
        uploadErrorConnection: 'Kunne ikke koble til serveren. Vennligst sjekk nettverket ditt og prøv igjen.',
        uploadErrorMessage: 'En uventet feil oppsto: {message}',
        dailyLimitExceeded: 'Daglig opplastingsgrense overskredet. Grense: {dailyLimit}',
        fileSizeExceeded: 'Filstørrelsen på {fileSize}MB overskrider den maksimalt tillatte størrelsen på {maxFileSize}MB.',
        insufficientStorage: 'Utilstrekkelig lagringsplass. Tilgjengelig: {availableStorage}GB.',
        unexpectedError: 'En uventet feil oppstod: {message}',
        connectionError: 'Kunne ikke koble til serveren. Vennligst sjekk nettverket ditt.',
        feedbackTitle: "Vi verdsetter tilbakemeldingen din!",
        feedbackPlaceholder: "Skriv inn tilbakemeldingen din her...",
        feedbackSubmitted: "Tilbakemelding sendt!",
        feedbackSent: "Tilbakemelding sendt!",
        sendFeedback: "Send tilbakemelding"
    },
    pl: {
        welcomeMessage: "🎬 Witamy w Vision AI Stream, {username}!",
        tagline: "🚀 Tnij, edytuj, łącz i spraw, by błyszczało – z VisionAI masz kontrolę!",
        upgradePlan: "Ulepsz plan",
        uploadVideo: 'Prześlij Wideo',
        uploadSubtitle: 'Prześlij Napisy',
        transcribe: 'Transkrypcja',
        embed: 'Osadź',
        dubbing: 'Dubbing',
        join: 'Połącz',
        cut: 'Wytnij',
        voiceClone: 'Klonowanie Głosu',
        lipMovement: 'Ruch Warg',
        lipEnhance: 'Poprawa Warg',
        startTime: 'Czas Rozpoczęcia',
        endTime: 'Czas Zakończenia',
        inputLanguage: 'Język Wejściowy',
        outputLanguage: 'Język Wyjściowy',
        page: "Strona",
        transitionRatioLabel: "Współczynnik przejścia",
        transitionRatioTooltip: "Określa, jak długo każdy napis pozostaje na ekranie. Wyższy = dłużej, Niższy = szybsza zmiana.",
        transitionRatioImageTooltip: "Wygenerowany film będzie trwał około {seconds} sekund.",
        dialoguePlaceholder: "Wpisz tylko jedno słowo kluczowe, aby wyciąć dialog lub temat",
        imagePromptPlaceholder: "Opisz, co powinno się wydarzyć na tym obrazie",
        cutOriginalVideo: 'Wytnij Oryginalne Wideo',
        cutSuccess: 'Wycięcie zakończone sukcesem!',
        downloadCutVideo: 'Pobierz Wycięte Wideo',
        downloadCutSubtitle: 'Pobierz Wycięte Napisy',
        processVideo: 'Przetwórz Wideo',
        cutVideoByDialogue: 'Wytnij Wideo na Podstawie Dialogu',
        cutVideoBySubtitle: 'Wytnij Wideo na Podstawie Napisów',
        uploadSuccess: 'Wideo pomyślnie przetworzono!',
        joinVideos: 'Połącz Wideo',
        joinSuccess: 'Wideo pomyślnie połączono!',
        joinError: 'Musisz mieć co najmniej dwa filmy do połączenia.',
        logout: 'Wyloguj się',
        cleanupSuccess: 'Czyszczenie zakończone sukcesem.',
        cleanupError: 'Błąd podczas czyszczenia.',
        logoutError: 'Błąd podczas wylogowania.',
        errorJoinVideos: 'Błąd podczas łączenia filmów.',
        audioError: 'Odtwarzanie dźwięku nie powiodło się.',
        audioUnsupported: 'Twoja przeglądarka nie obsługuje elementu dźwiękowego.',
        encodingNotSupported: 'Kodowanie nieobsługiwane:',
        fallbackUtf8: 'używając UTF-8 jako zapasowego.',
        errorDetectSubtitleLanguage: 'Błąd przy wykrywaniu języka napisów.',
        uploadVideoError: 'Proszę przesłać wideo przed wysłaniem.',
        uploadSubtitleError: 'Proszę przesłać napisy przed wysłaniem.',
        errorCorrectSubtitles: 'Błąd podczas korygowania napisów.',
        errorCutSubtitle: 'Błąd podczas dekodowania lub wycinania napisów.',
        uploadError: 'Błąd podczas przesyłania i wycinania wideo.',
        uploadErrorStatus: 'Rozmiar pliku {file.size} MB przekracza limit przesyłania. Serwer odpowiedział statusem: {status}',
        uploadErrorConnection: 'Nie udało się połączyć z serwerem. Sprawdź swoje połączenie sieciowe i spróbuj ponownie.',
        uploadErrorMessage: 'Wystąpił nieoczekiwany błąd: {message}',
        dailyLimitExceeded: 'Przekroczono dzienny limit przesyłania. Limit: {dailyLimit}',
        fileSizeExceeded: 'Rozmiar pliku {fileSize}MB przekracza dozwolony maksymalny rozmiar {maxFileSize}MB.',
        insufficientStorage: 'Niewystarczająca ilość miejsca. Dostępne: {availableStorage}GB.',
        unexpectedError: 'Wystąpił nieoczekiwany błąd: {message}',
        connectionError: 'Nie można połączyć się z serwerem. Sprawdź swoje połączenie sieciowe.',
        feedbackTitle: "Cenimy Twoją opinię!",
        feedbackPlaceholder: "Napisz tutaj swoją opinię...",
        feedbackSubmitted: "Opinia wysłana!",
        feedbackSent: "Opinia wysłana!",
        sendFeedback: "Wyślij opinię"
    },
    he: {
        welcomeMessage: "🎬 ברוך הבא ל-Vision AI Stream, {username}!",
        tagline: "🚀 חתוך, ערוך, שלב ותן לזה לזרוח – עם VisionAI, אתה בשליטה!",
        upgradePlan: "שדרג את התוכנית",
        uploadVideo: 'העלה וידאו',
        uploadSubtitle: 'העלה כתוביות',
        transcribe: 'תעתוק',
        embed: 'הטמע',
        dubbing: 'דיבוב',
        join: 'אחד',
        cut: 'חתוך',
        voiceClone: 'שיבוט קול',
        lipMovement: 'תנועת שפתיים',
        lipEnhance: 'שיפור שפתיים',
        startTime: 'זמן התחלה',
        endTime: 'זמן סיום',
        inputLanguage: 'שפת קלט',
        outputLanguage: 'שפת פלט',
        page: "דף",
        transitionRatioLabel: "יחס מעבר",
        transitionRatioTooltip: "קובע כמה זמן כל כתובית נשארת על המסך. ערך גבוה = נשארת יותר זמן, ערך נמוך = מתחלפת מהר.",
        transitionRatioImageTooltip: "משך הסרטון שייוצר יהיה כ־{seconds} שניות.",
        dialoguePlaceholder: "הזן רק מילת מפתח אחת כדי לחתוך את הדיאלוג או הנושא",
        imagePromptPlaceholder: "תאר מה צריך לקרות בתמונה הזו",
        cutOriginalVideo: 'חתוך את הווידאו המקורי',
        cutSuccess: 'החתך הושלם בהצלחה!',
        downloadCutVideo: 'הורד וידאו חתוך',
        downloadCutSubtitle: 'הורד כתוביות חתוכות',
        processVideo: 'עבד וידאו',
        cutVideoByDialogue: 'חתוך וידאו לפי דיאלוג',
        cutVideoBySubtitle: 'חתוך וידאו לפי כתוביות',
        uploadSuccess: 'הווידאו עובד בהצלחה!',
        joinVideos: 'אחד וידאו',
        joinSuccess: 'הווידאו אוחד בהצלחה!',
        joinError: 'דרושים לך לפחות שני סרטונים כדי לאחד.',
        logout: 'התנתק',
        cleanupSuccess: 'הניקוי הושלם בהצלחה.',
        cleanupError: 'שגיאה בניקוי.',
        logoutError: 'שגיאה ביציאה.',
        errorJoinVideos: 'שגיאה באיחוד הסרטונים.',
        audioError: 'השמעת השמע נכשלה.',
        audioUnsupported: 'הדפדפן שלך אינו תומך באלמנט השמע.',
        encodingNotSupported: 'קידוד לא נתמך:',
        fallbackUtf8: 'משתמש ב-UTF-8 כברירת מחדל.',
        errorDetectSubtitleLanguage: 'שגיאה בזיהוי שפת הכתוביות.',
        uploadVideoError: 'אנא העלה את הווידאו לפני שליחתו.',
        uploadSubtitleError: 'אנא העלה את הכתוביות לפני שליחתו.',
        errorCorrectSubtitles: 'שגיאה בתיקון הכתוביות.',
        errorCutSubtitle: 'שגיאה בפענוח או חיתוך הכתוביות.',
        uploadError: 'שגיאה בהעלאה וחיתוך של וידאו.',
        uploadErrorStatus: 'גודל הקובץ {file.size} MB חורג ממגבלת ההעלאה. השרת הגיב עם סטטוס: {status}',
        uploadErrorConnection: 'לא ניתן היה להתחבר לשרת. אנא בדוק את הרשת ונסה שוב.',
        uploadErrorMessage: 'אירעה שגיאה בלתי צפויה: {message}',
        dailyLimitExceeded: 'חריגה ממגבלת ההעלאה היומית. מגבלה: {dailyLimit}',
        fileSizeExceeded: 'גודל הקובץ {fileSize}MB חורג מהגודל המרבי המותר {maxFileSize}MB.',
        insufficientStorage: 'אין מספיק אחסון זמין. זמין: {availableStorage}GB.',
        unexpectedError: 'אירעה שגיאה בלתי צפויה: {message}',
        connectionError: 'לא ניתן היה להתחבר לשרת. אנא בדוק את החיבור שלך.',
        feedbackTitle: "אנחנו מעריכים את המשוב שלך!",
        feedbackPlaceholder: "כתוב כאן את המשוב שלך...",
        feedbackSubmitted: "המשוב נשלח!",
        feedbackSent: "המשוב נשלח!",
        sendFeedback: "שלח משוב"
    },
    fi: {
        welcomeMessage: "🎬 Tervetuloa Vision AI Streamiin, {username}!",
        tagline: "🚀 Leikkaa, muokkaa, yhdistä ja anna sen loistaa – VisionAI:llä sinä olet vastuussa!",
        upgradePlan: "Päivitä suunnitelma",
        uploadVideo: 'Lataa Video',
        uploadSubtitle: 'Lataa Tekstitys',
        transcribe: 'Transkriboi',
        embed: 'Upota',
        dubbing: 'Dubbaus',
        join: 'Yhdistä',
        cut: 'Leikkaa',
        voiceClone: 'Ääniklooni',
        lipMovement: 'Huulien Liike',
        lipEnhance: 'Huulien Parannus',
        startTime: 'Aloitusaika',
        endTime: 'Lopetusaika',
        inputLanguage: 'Syötekieli',
        outputLanguage: 'Tulostuskieli',
        page: "Sivu",
        transitionRatioLabel: "Siirtymäsuhde",
        transitionRatioTooltip: "Määrittää kuinka kauan jokainen tekstitys näkyy ruudulla. Korkeampi = pidempi näkyvyys, Matalampi = nopeampi vaihto.",
        transitionRatioImageTooltip: "Luodun videon kesto on noin {seconds} sekuntia.",
        dialoguePlaceholder: "Kirjoita vain yksi avainsana leikata keskustelu tai aihe",
        imagePromptPlaceholder: "Kuvaile, mitä tämän kuvan tulisi esittää",
        cutOriginalVideo: 'Leikkaa Alkuperäinen Video',
        cutSuccess: 'Leikkaus onnistui!',
        downloadCutVideo: 'Lataa Leikattu Video',
        downloadCutSubtitle: 'Lataa Leikattu Tekstitys',
        processVideo: 'Käsittele Video',
        cutVideoByDialogue: 'Leikkaa Video Vuoropuhelun Mukaan',
        cutVideoBySubtitle: 'Leikkaa Video Tekstityksen Mukaan',
        uploadSuccess: 'Video käsitelty onnistuneesti!',
        joinVideos: 'Yhdistä Videot',
        joinSuccess: 'Videot yhdistetty onnistuneesti!',
        joinError: 'Tarvitset vähintään kaksi videota yhdistämistä varten.',
        logout: 'Kirjaudu ulos',
        cleanupSuccess: 'Siivous onnistui.',
        cleanupError: 'Virhe siivouksessa.',
        logoutError: 'Virhe uloskirjautumisessa.',
        errorJoinVideos: 'Virhe videoiden yhdistämisessä.',
        audioError: 'Äänen toistaminen epäonnistui.',
        audioUnsupported: 'Selaimesi ei tue äänielementtiä.',
        encodingNotSupported: 'Koodausta ei tueta:',
        fallbackUtf8: 'käyttää UTF-8:aa varmuuskopiona.',
        errorDetectSubtitleLanguage: 'Virhe tekstityskielen tunnistamisessa.',
        uploadVideoError: 'Lataa video ennen lähettämistä.',
        uploadSubtitleError: 'Lataa tekstitys ennen lähettämistä.',
        errorCorrectSubtitles: 'Virhe tekstitysten korjaamisessa.',
        errorCutSubtitle: 'Virhe tekstityksen dekoodauksessa tai leikkaamisessa.',
        uploadError: 'Virhe videon lataamisessa ja leikkaamisessa.',
        uploadErrorStatus: 'Tiedoston koko {file.size} MB ylittää lähetysrajan. Palvelin vastasi tilalla: {status}',
        uploadErrorConnection: 'Yhteyttä palvelimeen ei voitu muodostaa. Tarkista verkkoyhteys ja yritä uudelleen.',
        uploadErrorMessage: 'Tapahtui odottamaton virhe: {message}',
        dailyLimitExceeded: 'Päivittäinen latausraja ylittyi. Raja: {dailyLimit}',
        fileSizeExceeded: 'Tiedoston koko {fileSize}MB ylittää sallitun enimmäiskoon {maxFileSize}MB.',
        insufficientStorage: 'Riittämätön tallennustila. Saatavilla: {availableStorage}GB.',
        unexpectedError: 'Tapahtui odottamaton virhe: {message}',
        connectionError: 'Yhteyttä palvelimeen ei voitu muodostaa. Tarkista verkko.',
        feedbackTitle: "Arvostamme palautettasi!",
        feedbackPlaceholder: "Kirjoita palautteesi tähän...",
        feedbackSubmitted: "Palaute lähetetty!",
        feedbackSent: "Palaute lähetetty!",
        sendFeedback: "Lähetä palaute"
    },
    el: {
        welcomeMessage: "🎬 Καλώς ήρθατε στο Vision AI Stream, {username}!",
        tagline: "🚀 Κόψτε, επεξεργαστείτε, ενώστε και κάντε το να λάμψει – με το VisionAI, έχετε τον έλεγχο!",
        upgradePlan: "Αναβάθμιση πλάνου",
        uploadVideo: 'Ανεβάστε Βίντεο',
        uploadSubtitle: 'Ανεβάστε Υπότιτλους',
        transcribe: 'Απομαγνητοφώνηση',
        embed: 'Ενσωμάτωση',
        dubbing: 'Μεταγλώττιση',
        join: 'Συγχώνευση',
        cut: 'Κοπή',
        voiceClone: 'Κλωνοποίηση Φωνής',
        lipMovement: 'Κίνηση Χειλιών',
        lipEnhance: 'Βελτίωση Χειλιών',
        startTime: 'Ώρα Έναρξης',
        endTime: 'Ώρα Λήξης',
        inputLanguage: 'Γλώσσα Εισαγωγής',
        outputLanguage: 'Γλώσσα Εξαγωγής',
        page: "Σελίδα",
        transitionRatioLabel: "Λόγος Μετάβασης",
        transitionRatioTooltip: "Καθορίζει πόσο μένει κάθε υπότιτλος. Μεγαλύτερο = περισσότερο, Μικρότερο = ταχύτερη αλλαγή.",
        transitionRatioImageTooltip: "Η διάρκεια του παραγόμενου βίντεο θα είναι περίπου {seconds} δευτερόλεπτα.",
        dialoguePlaceholder: "Εισαγάγετε μόνο μία λέξη-κλειδί για να αποκόψετε τον διάλογο ή το θέμα",
        imagePromptPlaceholder: "Περιγράψτε τι πρέπει να συμβεί σε αυτή την εικόνα",
        cutOriginalVideo: 'Κοπή Αρχικού Βίντεο',
        cutSuccess: 'Η κοπή ολοκληρώθηκε επιτυχώς!',
        downloadCutVideo: 'Λήψη Κομμένου Βίντεο',
        downloadCutSubtitle: 'Λήψη Κομμένων Υπότιτλων',
        processVideo: 'Επεξεργασία Βίντεο',
        cutVideoByDialogue: 'Κοπή Βίντεο κατά Διάλογο',
        cutVideoBySubtitle: 'Κοπή Βίντεο κατά Υπότιτλους',
        uploadSuccess: 'Το βίντεο επεξεργάστηκε επιτυχώς!',
        joinVideos: 'Συγχώνευση Βίντεο',
        joinSuccess: 'Τα βίντεο συγχωνεύτηκαν επιτυχώς!',
        joinError: 'Χρειάζεστε τουλάχιστον δύο βίντεο για συγχώνευση.',
        logout: 'Αποσύνδεση',
        cleanupSuccess: 'Ο καθαρισμός ολοκληρώθηκε επιτυχώς.',
        cleanupError: 'Σφάλμα κατά τον καθαρισμό.',
        logoutError: 'Σφάλμα κατά την αποσύνδεση.',
        errorJoinVideos: 'Σφάλμα κατά τη συγχώνευση βίντεο.',
        audioError: 'Η αναπαραγωγή ήχου απέτυχε.',
        audioUnsupported: 'Ο περιηγητής σας δεν υποστηρίζει το στοιχείο ήχου.',
        encodingNotSupported: 'Η κωδικοποίηση δεν υποστηρίζεται:',
        fallbackUtf8: 'χρησιμοποιώντας το UTF-8 ως εναλλακτική λύση.',
        errorDetectSubtitleLanguage: 'Σφάλμα κατά την ανίχνευση γλώσσας υπότιτλων.',
        uploadVideoError: 'Ανεβάστε το βίντεο πριν το αποστείλετε.',
        uploadSubtitleError: 'Ανεβάστε τους υπότιτλους πριν τους αποστείλετε.',
        errorCorrectSubtitles: 'Σφάλμα κατά τη διόρθωση υπότιτλων.',
        errorCutSubtitle: 'Σφάλμα κατά την αποκωδικοποίηση ή την κοπή των υπότιτλων.',
        uploadError: 'Σφάλμα κατά την αποστολή και την κοπή βίντεο.',
        uploadErrorStatus: 'Το μέγεθος αρχείου {file.size} MB υπερβαίνει το όριο μεταφόρτωσης. Ο διακομιστής απάντησε με κατάσταση: {status}',
        uploadErrorConnection: 'Δεν ήταν δυνατή η σύνδεση με τον διακομιστή. Ελέγξτε το δίκτυό σας και δοκιμάστε ξανά.',
        uploadErrorMessage: 'Παρουσιάστηκε ένα απροσδόκητο σφάλμα: {message}',
        dailyLimitExceeded: 'Υπερβήθηκε το ημερήσιο όριο μεταφόρτωσης. Όριο: {dailyLimit}',
        fileSizeExceeded: 'Το μέγεθος αρχείου {fileSize}MB υπερβαίνει το επιτρεπόμενο μέγιστο μέγεθος {maxFileSize}MB.',
        insufficientStorage: 'Ανεπαρκής αποθηκευτικός χώρος. Διαθέσιμο: {availableStorage}GB.',
        unexpectedError: 'Προέκυψε ένα απροσδόκητο σφάλμα: {message}',
        connectionError: 'Δεν ήταν δυνατή η σύνδεση με τον διακομιστή. Ελέγξτε το δίκτυό σας.',
        feedbackTitle: "Εκτιμούμε τα σχόλιά σας!",
        feedbackPlaceholder: "Γράψτε τα σχόλιά σας εδώ...",
        feedbackSubmitted: "Τα σχόλια υποβλήθηκαν!",
        feedbackSent: "Τα σχόλια υποβλήθηκαν!",
        sendFeedback: "Υποβολή σχολίων"
    },
    da: {
        welcomeMessage: "🎬 Velkommen til Vision AI Stream, {username}!",
        tagline: "🚀 Klip, rediger, saml og få det til at skinne – med VisionAI har du kontrollen!",
        upgradePlan: "Opgrader plan",
        uploadVideo: 'Upload Video',
        uploadSubtitle: 'Upload Undertekster',
        transcribe: 'Transskribere',
        embed: 'Indlejre',
        dubbing: 'Synkronisering',
        join: 'Sammenlægge',
        cut: 'Klippe',
        voiceClone: 'Stemme Kloning',
        lipMovement: 'Læbebevægelse',
        lipEnhance: 'Forbedring af Læber',
        startTime: 'Starttid',
        endTime: 'Sluttid',
        inputLanguage: 'Indgangssprog',
        outputLanguage: 'Udganssprog',
        page: "Side",
        transitionRatioLabel: "Overgangsforhold",
        transitionRatioTooltip: "Angiver hvor længe hver undertekst vises. Højere = længere tid, Lavere = hurtigere skift.",
        transitionRatioImageTooltip: "Den genererede video vil vare cirka {seconds} sekunder.",
        dialoguePlaceholder: "Indtast kun ét nøgleord for at klippe dialogen eller emnet",
        imagePromptPlaceholder: "Beskriv hvad der skal ske på dette billede",
        cutOriginalVideo: 'Klip Original Video',
        cutSuccess: 'Klipning gennemført!',
        downloadCutVideo: 'Download Klippet Video',
        downloadCutSubtitle: 'Download Klippet Undertekst',
        processVideo: 'Behandl Video',
        cutVideoByDialogue: 'Klip Video efter Dialog',
        cutVideoBySubtitle: 'Klip Video efter Undertekster',
        uploadSuccess: 'Video behandlet med succes!',
        joinVideos: 'Sammenlægge Videoer',
        joinSuccess: 'Videoer sammenlagt med succes!',
        joinError: 'Du skal bruge mindst to videoer til at sammenlægge.',
        logout: 'Log ud',
        cleanupSuccess: 'Oprydning gennemført.',
        cleanupError: 'Fejl under oprydning.',
        logoutError: 'Fejl ved udlogning.',
        errorJoinVideos: 'Fejl ved sammenlægning af videoer.',
        audioError: 'Afspilning af lyd mislykkedes.',
        audioUnsupported: 'Din browser understøtter ikke lydelementet.',
        encodingNotSupported: 'Kodning understøttes ikke:',
        fallbackUtf8: 'bruger UTF-8 som alternativ.',
        errorDetectSubtitleLanguage: 'Fejl ved registrering af undertekstsprog.',
        uploadVideoError: 'Upload videoen, før du sender den.',
        uploadSubtitleError: 'Upload underteksten, før du sender den.',
        errorCorrectSubtitles: 'Fejl ved korrektion af undertekster.',
        errorCutSubtitle: 'Fejl ved dekodning eller klipning af undertekster.',
        uploadError: 'Fejl ved upload og klipning af video.',
        uploadErrorStatus: 'Filstørrelsen på {file.size} MB overskrider uploadgrænsen. Serveren svarede med status: {status}',
        uploadErrorConnection: 'Kunne ikke oprette forbindelse til serveren. Kontroller dit netværk, og prøv igen.',
        uploadErrorMessage: 'Der opstod en uventet fejl: {message}',
        dailyLimitExceeded: 'Daglig uploadgrænse overskredet. Grænse: {dailyLimit}',
        fileSizeExceeded: 'Filstørrelsen på {fileSize}MB overstiger den maksimalt tilladte størrelse på {maxFileSize}MB.',
        insufficientStorage: 'Utilstrækkelig lagerplads. Tilgængelig: {availableStorage}GB.',
        unexpectedError: 'Der opstod en uventet fejl: {message}',
        connectionError: 'Kunne ikke oprette forbindelse til serveren. Kontroller dit netværk.',
        feedbackTitle: "Vi værdsætter din feedback!",
        feedbackPlaceholder: "Skriv din feedback her...",
        feedbackSubmitted: "Feedback sendt!",
        feedbackSent: "Feedback sendt!",
        sendFeedback: "Send feedback"
    }
};
